'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeOutLeftBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)('-2000px', 0, 0)
  }
};
exports.default = fadeOutLeftBig;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-out-left-big.js
// module id = 220
// module chunks = 54990529738226 257444579329143